// 굽기 누락 신고 — 구운 파일이 없거나·낡았거나·못 받았을 때 «런타임 계산으로 내려가지 않고» 터뜨린다.
//
// 규약: 굽기 누락을 감지한 그 자리에서 `throw bakeMissing(id, 무엇, 고치는 명령)` 한다.
//   · 같은 id 는 콘솔·서버·토스트에 **한 번만** 올린다(매 프레임 던져도 로그가 안 넘친다).
//   · 던진 쪽은 폴백을 돌리지 않는다 — 그 자리는 그려지지 않고, 운영자가 굽는다.
//   · 기기가 못 해서 나는 저하(워커 없음 등)는 여기가 아니라 `degradeRegistry.noteDegrade`.
// 탈출구: `?lodstrict=0` → `BAKE_STRICT=false`, 호출부가 옛 폴백으로 간다(굽기 파이프라인 고장 시 비상문).
// 읽는 법: 게임 안 토스트 · `window.__bakeMissing()` · 서버 client_debug 로그의 `bake-missing`.
import { reportEventNow } from './clientLogReporter';
import { toast } from '@ui/overlay/toastStore';
import { LOD_STRICT_BAKED } from '@entity/world/hfConstants';

export const BAKE_STRICT = LOD_STRICT_BAKED;

const _fired = new Map();   // id → { id, what, fix, at }

/**
 * 굽기 누락을 신고하고 던질 Error 를 돌려준다. 호출부: `throw bakeMissing(...)`.
 * @param {string} id   같은 누락을 묶는 키(예: 'road:fp', 'lod:b4_-4')
 * @param {string} what 무엇이 없나(사람이 읽는 한 줄)
 * @param {string} [fix] 굽는 명령
 */
export function bakeMissing(id, what, fix = '') {
  const msg = `[굽기 누락] ${what}${fix ? ` — 구우십시오: ${fix}` : ''}  ·  임시로 넘기려면 URL 에 ?lodstrict=0`;
  if (!_fired.has(id)) {
    _fired.set(id, { id, what, fix, at: Date.now() });
    console.error(`${msg}  (id=${id})`);
    try { reportEventNow('bake-missing', `${id} | ${what}${fix ? ` | ${fix}` : ''}`); } catch { /* 로그가 막혀도 신고는 콘솔에 남았다 */ }
    try { toast.err(`굽기 누락 — ${what}`, { detail: fix || undefined, ms: 20000 }); } catch { /* 표시부 전 */ }
  }
  const e = new Error(msg);
  e.bakeMissing = id;
  return e;
}

export const bakeMissingList = () => [..._fired.values()];
if (typeof window !== 'undefined') window.__bakeMissing = bakeMissingList;
